/**
 * Common enum dropdown component connected to create form provider
 */
import { useRfiFormField } from '../../../RfiCreateForm/RfiFormProvider';
import { EnumDropdown, EnumDropdownProps } from './EnumDropdown';

export const EnumDropdownCreateForm = (props: EnumDropdownProps) => {
  const { fieldName } = props;
  const { isFieldsMandatory, isSubmitting, fieldRef } = useRfiFormField(fieldName);

  return (
    <EnumDropdown {...props} ref={fieldRef} disabled={isSubmitting} required={isFieldsMandatory} />
  );
};
